import instance from '@/api/business' 
import {
    MarketResearch,
    ProductsNotSearched,
    ResearchCoverage,
    PackagingStatus,
    PackagingProduct,
    SavePackagingResearchPayload,
    UserDashboardSummary
} from '@/types/MarketResearch'
import { 
    CreateMarketResearch, 
    UpdateMarketResearch,
    DeleteMarketResearch,
    InsertProductsInMarketResearchProps, 
    ProductMarketResearch, 
    PDVMarketResearch, 
    DeletProductMarketResearch, 
    ChangeStatusMarketResearch,
    ProductFromPDVMarketResearch,
    CreateResearchedProduct,
    ResearchedProduct,
    DeleteImageResearchedProduct,
    UploadImageResearchedProduct,
    DeleteResearchedProduct,
    MarkProductMarketResearch,
    UpdateResearchedProductProps,
    ChannelMarketResearch,
    SaveChannelsInMarketResearchProps,
    EmployeeMarketResearch,
    SaveEmployeesInMarketResearchProps
} from './type'


const BASE_URL_MARKET_RESEARCH = '/marketresearch/im/marketresearch' 
const BASE_URL_RESEARCHED_PRODUCT = '/marketresearch/im/researchedproduct'
const BASE_URL_PRODUCT = '/marketresearch/im/product'
const BASE_URL_CHANNEL = '/marketresearch/im/channel'

export interface FetchMarketResearchPayload {
    SK_TEMPO_INICIO?: number
    SK_TEMPO_FIM?: number
    DD_STATUS?: string[] | string
    SK_REVENDAS?: number[]
    SK_REVENDA?: number
    SEARCH_TERM?: string
}

export const fetchMarketResearch = async (payload?: FetchMarketResearchPayload) => {
    const response = await instance.post<MarketResearch[]>(BASE_URL_MARKET_RESEARCH, payload || {})

    return response.data
}

export const fetchMarketResearchById = async (SK_PESQUISA: number) => {
    const response = await instance.post<MarketResearch[]>(`${BASE_URL_MARKET_RESEARCH}byid`,{
        SK_PESQUISA: SK_PESQUISA 
    })

    return response.data
}

export const createMarketResearch = async (data: CreateMarketResearch) => {
     const response = await instance.put(BASE_URL_MARKET_RESEARCH, data)
 
     return response.data
} 

export const updateMarketResearch = async (data: UpdateMarketResearch) => {
    const response = await instance.patch(BASE_URL_MARKET_RESEARCH, data)

    return response.data
}

export const deleteMarketResearch = async (data: DeleteMarketResearch) => {
    const response = await instance.delete(BASE_URL_MARKET_RESEARCH, {
        data: data,
    })

    return response.data
}

export const changeStatusMarketResearch = async (data: ChangeStatusMarketResearch) => {
    const response = await instance.patch('/marketresearch/im/changestatusmarketresearch', 
        data
    )
    
    return response.data 
}

export const fetchResearchCoverage = async (SK_PESQUISA: number) => {
    const response = await instance.post<ResearchCoverage[]>(`/marketresearch/im/researchcoverage`,{
        SK_PESQUISA: SK_PESQUISA 
    })

    return response.data
}

export const fetchResearchCoverageProductsNotSearched = async (SK_PESQUISA: number) => {
    const response = await instance.post<ProductsNotSearched[]>(`/marketresearch/im/researchcoverageproductsnotsearched`,{
        SK_PESQUISA: SK_PESQUISA 
    })

    return response.data
}


export const fetchProductInMarketResearch = async (SK_PESQUISA: number) => {
    const response = await instance.post<ProductMarketResearch[]>(BASE_URL_PRODUCT,{
        SK_PESQUISA: SK_PESQUISA 
    })

    return response.data
}

export const createProductInMarketResearch = async (data: InsertProductsInMarketResearchProps) => {
    const response = await instance.put(BASE_URL_PRODUCT, data)

    return response.data
}

export const deleteProductInMarketResearch = async (data: DeletProductMarketResearch) => {
    const response = await instance.delete(BASE_URL_PRODUCT,  {
        data: data,
    })
    
    return response.data 
}


export const fetchProductFromPDVInMarketResearch = async (SK_PESQUISA: number, SK_CLIENTE: number) => {
    const response = await instance.post<ProductFromPDVMarketResearch[]>(`/marketresearch/im/productfrompdv`,{
        SK_PESQUISA: SK_PESQUISA,
        SK_CLIENTE: SK_CLIENTE
    })

    return response.data
} 

export const fetchPDVInMarketResearch = async (SK_PESQUISA: number) => {
    const response = await instance.post<PDVMarketResearch[]>(`/marketresearch/im/pdv`,{
        SK_PESQUISA: SK_PESQUISA 
    })

    return response.data
}


export const createResearchedProduct = async (props: CreateResearchedProduct) => {
    const formData = new FormData();
    
    for (const [key, value] of Object.entries(props)) {
        formData.append(key, value);
    } 

    const res = await instance.put(BASE_URL_RESEARCHED_PRODUCT, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });

    return res.data;
};

export const updateResearchedProduct = async (data: UpdateResearchedProductProps) => {
    const response = await instance.patch(BASE_URL_RESEARCHED_PRODUCT, {
        ...data
    })

    return response.data 
}

export const fetchResearchedProduct = async (SK_PESQUISA: number) => {
    const response = await instance.post<ResearchedProduct[]>(BASE_URL_RESEARCHED_PRODUCT, {
        SK_PESQUISA: SK_PESQUISA
    })

    return response.data 
}

export const deleteResearchedProduct = async (data: DeleteResearchedProduct) => {
    const response = await instance.delete(BASE_URL_RESEARCHED_PRODUCT,  {
        data: data,
    })
    
    return response.data 
}

export const fetchImageResearchedProduct = async (DS_CHAVE_ARQUIVO: string) => {
    console.log(DS_CHAVE_ARQUIVO)
    const response = await instance.post<{url: string}>('/marketresearch/im/imageresearchedproduct', {
        DS_CHAVE_ARQUIVO: DS_CHAVE_ARQUIVO
    })

    return response.data 
}

export const deleteImageResearchedProduct = async (data: DeleteImageResearchedProduct) => {
    const response = await instance.delete('/marketresearch/im/imageresearchedproduct',  {
        data: data,
    })
    
    return response.data 
}

export const uploadImageResearchedProduct = async (props: UploadImageResearchedProduct) => {
    const formData = new FormData();

    for (const [key, value] of Object.entries(props)) {
        if (value) {
        formData.append(key, value);
        }
    }

    const res = await instance.patch('/marketresearch/im/imageresearchedproduct', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data;
};


export const publishResearchedProduct = async (SK_PRODUTOS_PESQUISADOS: number) => {
    const response = await instance.patch('/marketresearch/im/publishresearchedproduct', {
        SK_PRODUTOS_PESQUISADOS: SK_PRODUTOS_PESQUISADOS
    })

    return response.data 
}


export const fetchMarkProductInMarketResearch = async (SK_PESQUISA: number) => {
    const response = await instance.post<MarkProductMarketResearch[]>('/marketresearch/im/markproduct',{
        SK_PESQUISA: SK_PESQUISA 
    })

    return response.data
}

export const fetchChannelsInMarketResearch = async (SK_PESQUISA: number) => {
    const response = await instance.post<ChannelMarketResearch[]>(BASE_URL_CHANNEL, {
        SK_PESQUISA: SK_PESQUISA,
    })

    return response.data
}

export const saveChannelsInMarketResearch = async (data: SaveChannelsInMarketResearchProps) => {
    const response = await instance.put(BASE_URL_CHANNEL, data)

    return response.data
}

export const fetchEmployeesInMarketResearch = async (SK_PESQUISA: number) => {
    const response = await instance.post<EmployeeMarketResearch[]>('/marketresearch/im/employee-market-research', {
        SK_PESQUISA: SK_PESQUISA,
    })

    return response.data
}

export const saveEmployeesInMarketResearch = async (data: SaveEmployeesInMarketResearchProps) => {
    const response = await instance.put('/marketresearch/im/employee-market-research', data)

    return response.data
}

export const fetchPackagings = async (SK_PESQUISA: number, SK_CLIENTE: number) => {
    const response = await instance.post<PackagingStatus[]>('/marketresearch/im/packagings', {
        SK_PESQUISA,
        SK_CLIENTE,
    })
    return response.data
}

export const fetchProductsByPackaging = async (SK_PESQUISA: number, SK_CLIENTE: number, DD_SKU: string) => {
    const response = await instance.post<PackagingProduct[]>('/marketresearch/im/products-by-packaging', {
        SK_PESQUISA,
        SK_CLIENTE,
        DD_SKU,
    })
    return response.data
}

export const savePackagingResearch = async (data: SavePackagingResearchPayload) => {
    const response = await instance.put('/marketresearch/im/save-packaging-research', data)
    return response.data
}

export interface CorrectPublishedResearchPayload {
    SK_PRODUTOS_PESQUISADOS: number
    VL_PRECO_COMPRA?: number | null
    QTD_VOLUME_COMPRA?: number | null
    VL_PRECO_VENDA?: number | null
    SK_MOTIVO_NAO_PESQUISA?: number | null
    DS_JUSTIFICATIVA?: string
}

export interface FetchResearchAuditHistoryPayload {
    SK_PESQUISA?: number
    SK_PRODUTOS_PESQUISADOS?: number
    SK_CLIENTE?: number
}

export interface ResearchAuditItem {
    SK_AUDITORIA_PESQUISA: number
    SK_PRODUTOS_PESQUISADOS?: number
    SK_PESQUISA: number
    SK_CLIENTE: number
    DS_NOME_FANTASIA?: string
    SK_PRODUTO: number
    DS_PRODUTO?: string
    SK_USUARIO: number
    NM_USUARIO?: string
    NM_CAMPO: string
    VL_ANTERIOR?: string
    VL_NOVO?: string
    DS_JUSTIFICATIVA?: string
    DT_ALTERACAO: string
}

export const publishClientResearch = async (SK_PESQUISA: number, SK_CLIENTE: number) => {
    const response = await instance.patch('/marketresearch/im/publish-client-research', {
        SK_PESQUISA,
        SK_CLIENTE,
    })
    return response.data
}

export const correctPublishedResearch = async (data: CorrectPublishedResearchPayload) => {
    const response = await instance.patch('/marketresearch/im/correct-published-research', data)
    return response.data
}

export const fetchResearchAuditHistory = async (payload: FetchResearchAuditHistoryPayload) => {
    const response = await instance.post<ResearchAuditItem[]>('/marketresearch/im/research-audit-history', payload)
    return response.data
}

export interface SellerCoverageItem {
    SK_VENDEDOR: string | number
    NK_FUNCIONARIO: string
    NM_FUNCIONARIO: string
    SK_REVENDA: number
    DS_REVENDA: string
    SK_PESQUISA: number
    NM_PESQUISA: string
    QTD_CLIENTES_PREVISTOS: number
    QTD_PESQUISAS_REALIZADAS: number
    QTD_PESQUISAS_PENDENTES: number
    PERC_COBERTURA: number
}

export interface FetchSellerCoveragePayload {
    SK_PESQUISA?: number
    SK_PESQUISAS?: number[]
    SK_REVENDA?: number
    SK_REVENDAS?: number[]
    SEARCH_TERM?: string
}

export const fetchSellerCoverageReport = async (payload: FetchSellerCoveragePayload = {}) => {
    const response = await instance.post<SellerCoverageItem[]>('/marketresearch/im/seller-coverage-report', payload)
    return response.data
}

export interface SellerCoverageResearchedItem {
    SK_PRODUTOS_PESQUISADOS: number
    SK_PESQUISA: number
    NM_PESQUISA: string
    SK_CLIENTE: number
    DS_NOME_FANTASIA: string
    DS_REVENDA: string
    SK_VENDEDOR: string | number
    NM_FUNCIONARIO: string
    SK_PRODUTO: number
    DS_PRODUTO: string
    VL_PRECO_COMPRA: number | null
    QTD_VOLUME_COMPRA: number | null
    VL_PRECO_VENDA: number | null
    DS_MOTIVO_NAO_PESQUISA: string | null
    DD_STATUS: string
    DT_PUBLICACAO: string | null
    CREATED_AT: string
}

export interface FetchSellerCoverageItemsPayload {
    SK_PESQUISA: number
    SK_VENDEDOR: string | number
}

export const fetchSellerCoverageItems = async (payload: FetchSellerCoverageItemsPayload) => {
    const response = await instance.post<SellerCoverageResearchedItem[]>('/marketresearch/im/seller-coverage-items', payload)
    return response.data
}

export interface ResellerCoverageItem {
    SK_REVENDA: number
    DS_REVENDA: string
    SK_PESQUISA: number
    NM_PESQUISA: string
    QTD_CLIENTES_PREVISTOS: number
    QTD_PESQUISAS_REALIZADAS: number
    QTD_PESQUISAS_PENDENTES: number
    PERC_COBERTURA: number
}

export interface FetchResellerCoveragePayload {
    SK_PESQUISA?: number
    SK_PESQUISAS?: number[]
    SK_REVENDA?: number
    SK_REVENDAS?: number[]
    SEARCH_TERM?: string
}

export const fetchResellerCoverageReport = async (payload: FetchResellerCoveragePayload = {}) => {
    const response = await instance.post<ResellerCoverageItem[]>('/marketresearch/im/reseller-coverage-report', payload)
    return response.data
}

export interface FetchResellerCoverageItemsPayload {
    SK_PESQUISA: number
    SK_REVENDA: number
}

export const fetchResellerCoverageItems = async (payload: FetchResellerCoverageItemsPayload) => {
    const response = await instance.post<SellerCoverageResearchedItem[]>('/marketresearch/im/reseller-coverage-items', payload)
    return response.data
}

export const fetchUserDashboardSummary = async () => {
    const response = await instance.post<UserDashboardSummary>('/marketresearch/im/user-dashboard-summary')
    return response.data
}





